import React, { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import HeaderLogo from '../HeaderLogo';
import RightMenu from './RightMenu';
import MenuItem from './MenuItem';

import { DesktopMenuContainer, DesktopMenuItems } from './styles';
import './styles.less';

const DesktopMenu = ({
  className,
  navigationMenu,
  logoProps,
  rightMenuProps,
  showMainMenuItems,
}) => {
  useEffect(() => {
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = 'auto';
    }
  }, []);

  return (
    <DesktopMenuContainer className={twMerge('desktop-header', className)}>
      <HeaderLogo {...logoProps} />
      {showMainMenuItems && (
        <DesktopMenuItems className="desktop-menu-items">
          {navigationMenu.map((menu, index) => {
            const label = menu.label?.toLowerCase();
            const type = [
              'solutions',
              'resources',
              'products',
              'commercial',
              'residential',
            ].includes(label)
              ? label
              : 'simple';

            return (
              <MenuItem
                key={`menu-item-${index}`}
                menu={menu}
                type={type}
                className={`${type}-menu-modal ${label.replace(' ', '-')}`}
              />
            );
          })}
        </DesktopMenuItems>
      )}
      <RightMenu {...rightMenuProps} />
    </DesktopMenuContainer>
  );
};

export default DesktopMenu;
